<div class="modal-section-header w-100">
    {{sectionTitle | translate}}
</div>
